import { PageHeader } from "components";
import type { NextPage } from "next";
import {
  DeliverySection,
  HeroSection,
  JetsonOneSection,
  LatestNewsSection,
  NewsletterSection,
} from "sections";
import {
  IArticleV3Fields,
  IDeliverySectionFields,
  INews,
  IStaticJetsonOneSectionFields,
  IStaticNewsletterSectionFields,
} from "types";
import { getContentfulEntries, toNewsListItem } from "utils/contentful-api";

const Home: NextPage<{
  news: INews[];
  jetsonOne: IStaticJetsonOneSectionFields[];
  delivery: IDeliverySectionFields[];
  newsletter: IStaticNewsletterSectionFields[];
}> = ({ news, jetsonOne, delivery, newsletter }) => {
  return (
    <div>
      <PageHeader title="Home" />
      <HeroSection />
      <JetsonOneSection jetsonOne={jetsonOne} />
      <DeliverySection deliverySection={delivery} />
      <LatestNewsSection news={news} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};

export default Home;

export async function getStaticProps() {
  const newsEntries = await getContentfulEntries<IArticleV3Fields>(
    "articleV3",
    "-sys.createdAt",
    10
  );

  const news: INews[] = newsEntries.map(toNewsListItem);

  const jetsonOne: IStaticJetsonOneSectionFields[] = [
    {
      title: "Jetson ONE",
      description:
        "Your personal aircraft in aluminium and carbon fiber, powered with eight powerful electric motors.",
      buttonText: "More details",
      buttonUrl: "jetson-one",
    },
  ];

  const delivery = await getContentfulEntries<IDeliverySectionFields>(
    "deliverySection"
  );

  const newsletter = await getContentfulEntries<IStaticNewsletterSectionFields>(
    "newsletterSection"
  );

  return {
    props: {
      news,
      jetsonOne,
      delivery,
      newsletter,
    },
    revalidate: 3600, // Revalidate every hour
  };
}
